module.exports = __webpack_public_path__ + "static/KIN3-f91d02195583108b53bd45a0bf095a86.png";